var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22527_234622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7672 5.00841C15.6005 4.51675 15.1338 4.16675 14.5838 4.16675H5.41715C4.86715 4.16675 4.40882 4.51675 4.23382 5.00841L2.59215 9.73341C2.53382 9.90841 2.50049 10.0917 2.50049 10.2834V16.2501C2.50049 16.9417 3.05882 17.5001 3.75049 17.5001C4.44215 17.5001 5.00049 16.9417 5.00049 16.2501V15.8334H15.0005V16.2501C15.0005 16.9334 15.5588 17.5001 16.2505 17.5001C16.9338 17.5001 17.5005 16.9417 17.5005 16.2501V10.2834C17.5005 10.1001 17.4672 9.90841 17.4088 9.73341L15.7672 5.00841ZM5.41715 13.3334C4.72549 13.3334 4.16715 12.7751 4.16715 12.0834C4.16715 11.3917 4.72549 10.8334 5.41715 10.8334C6.10882 10.8334 6.66715 11.3917 6.66715 12.0834C6.66715 12.7751 6.10882 13.3334 5.41715 13.3334ZM14.5838 13.3334C13.8922 13.3334 13.3338 12.7751 13.3338 12.0834C13.3338 11.3917 13.8922 10.8334 14.5838 10.8334C15.2755 10.8334 15.8338 11.3917 15.8338 12.0834C15.8338 12.7751 15.2755 13.3334 14.5838 13.3334ZM4.16715 9.16675L5.22549 5.98341C5.34215 5.65008 5.65882 5.41675 6.01715 5.41675H13.9838C14.3422 5.41675 14.6588 5.65008 14.7755 5.98341L15.8338 9.16675H4.16715Z",
    fill: "#6B7684"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22527_234622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/carIcon.9cf84d0e223b045803f6ec942900da79.svg";
export { ForwardRef as ReactComponent };